import { render, staticRenderFns } from "./UiTextButton.vue?vue&type=template&id=296d18be&"
import script from "./UiTextButton.vue?vue&type=script&lang=js&"
export * from "./UiTextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports